import { browser } from '$app/environment';
import { writable } from 'svelte/store';

export const isOnline = writable(false);

if (typeof window !== 'undefined') {
    // client-only code here
    isOnline.set(navigator?.onLine);

    function updateOnlineStatus() {
        if (!browser || !navigator) return;
        isOnline.set(navigator?.onLine);
    }

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
}